export default __webpack_public_path__ + "static/media/rate-service.7dcc097f.svg";